/* ==========================================================================
 * custom-bundle.js — Quantity Bundle Widget
 * --------------------------------------------------------------------------
 * - Gia sau giam tinh REAL-TIME tu data attributes (khong hardcode).
 * - Anh nho theo mau (thumbnail variant) o moi o chon.
 * - Custom name dang POPUP (Personalisation), moi don vi 1 dong.
 * - Free shipping chi hien khi qty tier >= nguong (free_shipping_min_qty).
 * - Sync: chon Color (variant picker theme) -> dien tat ca o cua tier.
 * - Add nhieu variant vao gio qua /cart/add.js (items:[...]), gan _bundle_id
 *   va _bundle_discount (de Shopify Function tru dung % o checkout).
 * ========================================================================== */
(function () {
  'use strict';

  /* Format tien theo dung money_format cua shop (giong Shopify.formatMoney) —
     nhat quan voi theme, khong doi theo locale trinh duyet. */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = formatString.match(placeholderRegex);
    var placeholder = match ? match[1] : 'amount';
    var value;
    switch (placeholder) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ''); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'"); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' '); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      default: value = withDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function makeMoneyFormatter(format, currency) {
    var hasFormat = format && /\{\{\s*\w+\s*\}\}/.test(format);
    return function (cents) {
      if (hasFormat) return formatMoney(cents, format);
      // Khong co money_format -> fallback Intl theo currency
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format((cents || 0) / 100);
      } catch (e) {
        return formatMoney(cents, '${{amount}}');
      }
    };
  }

  function applyDiscount(cents, percent) {
    if (!percent) return cents;
    return Math.round((cents * (100 - percent)) / 100);
  }

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        document
          .querySelectorAll('.cart-count-bubble span[aria-hidden], .cart-count-bubble, .cart-count, [data-cart-count], .header__cart-count, .site-header__cart-count')
          .forEach(function (el) {
            if (el.hasAttribute('data-cart-count') || /count/.test(el.className)) el.textContent = count;
          });
        return cart;
      })
      .catch(function () {});
  }

  function notifyThemeCart(cart, addedItems) {
    var handled = false;
    try {
      if (window.Shopify && window.Shopify.publish && window.PUB_SUB_EVENTS) {
        window.Shopify.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'custom-bundle', cartData: cart });
        handled = true;
      }
    } catch (e) {}
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      try {
        if (typeof drawer.renderContents === 'function' && cart && cart.sections) drawer.renderContents(cart);
        if (typeof drawer.open === 'function') drawer.open();
        else drawer.classList.add('active', 'is-open', 'open');
        handled = true;
      } catch (e) {}
    }
    ['cart:refresh', 'cart:updated', 'cart:build', 'ajaxProduct:added'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { detail: { cart: cart, items: addedItems } }));
    });
    if (window.jQuery) { try { window.jQuery(document.body).trigger('cart:updated', [cart]); } catch (e) {} }
    return handled;
  }

  function showToast(msg) {
    var t = document.createElement('div');
    t.textContent = msg;
    t.setAttribute('role', 'status');
    t.style.cssText =
      'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);' +
      'background:#1a1a1a;color:#fff;padding:.7rem 1.1rem;border-radius:999px;' +
      'font-size:.9rem;z-index:99999;box-shadow:0 6px 20px rgba(0,0,0,.25);opacity:0;transition:opacity .2s';
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.style.opacity = '1'; });
    setTimeout(function () { t.style.opacity = '0'; setTimeout(function () { t.remove(); }, 250); }, 2200);
  }

  /* ====================================================================== */
  function initBundle(root) {
    if (root.dataset.cbndlInit) return;
    root.dataset.cbndlInit = '1';

    var money = makeMoneyFormatter(root.dataset.moneyFormat, root.dataset.currency);
    var enableCustomName = root.dataset.enableCustomName === 'true';
    var cartBehavior = root.dataset.cartBehavior || 'auto';
    var productTitle = root.dataset.productTitle || 'Item';
    var freeShipMin = parseInt(root.dataset.freeShipMin, 10) || 0;

    // Personalization: 'custom_name' (1 o ten/mon nhu cu) hoac 'fields'
    // (cac field cau hinh tu metafield custom.personalization_fields).
    var personalizationMode = root.dataset.personalizationMode || 'custom_name';
    var pfFields = [];
    try {
      var pfEl = root.querySelector('[data-cn-fields]');
      if (pfEl) pfFields = JSON.parse(pfEl.textContent || '[]');
    } catch (e) { pfFields = []; }
    pfFields = (pfFields || []).filter(function (f) {
      return f && (f.type === 'text' || f.type === 'dropdown' || f.type === 'file' || !f.type);
    });
    var useFields = personalizationMode === 'fields' && pfFields.length > 0;
    // Co field file -> phai add-to-cart bang multipart (JSON khong gui file duoc).
    var hasFileField = pfFields.some(function (f) { return f.type === 'file'; });

    /* ---- Phi ca nhan hoa (add-on) ----
       Field co gia (add_on_price / gia option) duoc thu bang cach them dong san pham
       `personalization-fee` (moi muc gia = 1 variant, khop theo SKU) CUNG request voi
       cac mon chinh. Xem snippet personalization-fee-map + assets/personalization-fee-guard.js. */
    var feeMap = {};
    try { feeMap = JSON.parse(root.dataset.feeMap || '{}') || {}; } catch (e) { feeMap = {}; }
    function feeEntry(cents) {
      var e = feeMap[String(cents)];
      return e && e.id && e.ok !== false ? e : null;
    }
    function toCents(v) { return parseInt(v, 10) > 0 ? parseInt(v, 10) : 0; }
    // Moi muc gia (cents) ma bat ky field nao co the phat sinh.
    function pricedLevels(fields) {
      var lv = {};
      fields.forEach(function (f) {
        if (toCents(f.add_on_price)) lv[toCents(f.add_on_price)] = true;
        (f.options || []).forEach(function (o) {
          if (o && typeof o === 'object' && toCents(o.price)) lv[toCents(o.price)] = true;
        });
      });
      return Object.keys(lv).map(Number);
    }
    // Thieu variant phi cho 1 muc gia -> khach nhap field ma khong bi tinh tien.
    // Khong lieu: quay ve o ten don gian (khong co add-on) va bao trong console.
    var feeLevels = pricedLevels(pfFields);
    var feeMissing = feeLevels.filter(function (c) { return !feeEntry(c); });
    if (feeMissing.length) {
      if (window.console) console.warn('[custom-bundle] Missing personalization-fee variant (SKU) for cents: ' + feeMissing.join(', ') + ' - falling back to simple name field.');
      personalizationMode = 'custom_name';
      pfFields = [];
      useFields = false;
      hasFileField = false;
      feeLevels = [];
    }
    // Tien add-on (cents, theo tien shop) cua 1 field voi gia tri khach nhap.
    function fieldFeeCents(pf, value, hasFile) {
      if (pf.type === 'file') return hasFile ? toCents(pf.add_on_price) : 0;
      if (!value) return 0;
      if (pf.type === 'dropdown') {
        var hit = (pf.options || []).filter(function (o) {
          return (o && typeof o === 'object' ? o.label : o) === value;
        })[0];
        var op = hit && typeof hit === 'object' ? toCents(hit.price) : 0;
        return op || toCents(pf.add_on_price);
      }
      return toCents(pf.add_on_price);
    }
    // Cac muc phi (cents) cua 1 mon: [500, 500, 1000...].
    function unitFeeComponents(card, idx) {
      var vals = (card.__cnFields || [])[idx] || {};
      var files = (card.__cnFiles || [])[idx] || {};
      var out = [];
      pfFields.forEach(function (pf) {
        var c = fieldFeeCents(pf, vals[pf.label], !!files[pf.label]);
        if (c > 0) out.push(c);
      });
      return out;
    }
    // Phi cua ca goi: { total (gia hien thi), byVariant: { id: {qty, price} } }.
    function cardFee(card) {
      var res = { total: 0, byVariant: {} };
      if (!useFields || !feeLevels.length) return res;
      var qty = parseInt(card.dataset.qty, 10) || 1;
      for (var i = 0; i < qty; i++) {
        unitFeeComponents(card, i).forEach(function (c) {
          var e = feeEntry(c);
          if (!e) return;
          var slot = res.byVariant[e.id] || (res.byVariant[e.id] = { qty: 0, price: e.price });
          slot.qty += 1;
          res.total += e.price;
        });
      }
      return res;
    }
    // Che do fields nhung san pham KHONG co field nao -> an nut personalize,
    // khong fallback ve custom name (mua theo mau co san, khong custom chu).
    if (personalizationMode === 'fields' && !useFields) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-cn-open]'), function (b) {
        b.style.display = 'none';
      });
    }

    var cards = Array.prototype.slice.call(root.querySelectorAll('.cbndl__card'));
    var submitBtn = root.querySelector('[data-submit]');
    var submitText = root.querySelector('[data-submit-text]');
    var spinner = root.querySelector('[data-spinner]');
    var errorEl = root.querySelector('[data-error]');
    var shipTeaser = root.querySelector('[data-ship-teaser]');

    function optData(select) {
      var opt = select.options[select.selectedIndex];
      return {
        id: opt.value,
        price: parseInt(opt.dataset.price, 10) || 0,
        compare: parseInt(opt.dataset.compare, 10) || parseInt(opt.dataset.price, 10) || 0,
        available: opt.dataset.available === 'true',
        image: opt.dataset.image || '',
        label: opt.textContent
      };
    }

    /* -- Cap nhat khoi gia cho 1 tier card -- */
    function renderCardPrice(card) {
      var qty = parseInt(card.dataset.qty, 10) || 1;
      var discount = parseInt(card.dataset.discount, 10) || 0;
      var selects = card.querySelectorAll('.cbndl__select');

      var totalAnchor = 0;
      var totalNow = 0;
      selects.forEach(function (s) {
        var d = optData(s);
        totalAnchor += d.compare;
        totalNow += applyDiscount(d.price, discount);
      });
      // Phi ca nhan hoa khong duoc giam theo goi -> cong thang vao ca gia that lan gia gach.
      var feeNow = cardFee(card).total;
      totalAnchor += feeNow;
      totalNow += feeNow;
      var unitAnchor = Math.round(totalAnchor / qty);
      var unitNow = Math.round(totalNow / qty);

      var unitPriceEl = card.querySelector('[data-unit-price]');
      var unitCompareEl = card.querySelector('[data-unit-compare]');
      var totalPriceEl = card.querySelector('[data-total-price]');
      var totalCompareEl = card.querySelector('[data-total-compare]');

      // Moi the chi 1 so chinh + 1 so gach (dong deu): qty1 -> don gia, qty>1 -> tong.
      if (qty > 1) {
        if (unitPriceEl) unitPriceEl.textContent = '';
        if (unitCompareEl) unitCompareEl.textContent = '';
        if (totalPriceEl) totalPriceEl.textContent = money(totalNow);
        if (totalCompareEl) totalCompareEl.textContent = totalAnchor > totalNow ? money(totalAnchor) : '';
      } else {
        if (unitPriceEl) unitPriceEl.textContent = money(unitNow);
        if (unitCompareEl) unitCompareEl.textContent = unitAnchor > unitNow ? money(unitAnchor) : '';
        if (totalPriceEl) totalPriceEl.textContent = '';
        if (totalCompareEl) totalCompareEl.textContent = '';
      }
    }

    /* -- Cap nhat hien thi dropdown tuy bien (anh + ten + active) theo select -- */
    function updateDropdownDisplay(select) {
      var row = select.closest('.cbndl__selector-row');
      if (!row) return;
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      var thumb = row.querySelector('[data-dd-thumb]');
      var label = row.querySelector('[data-dd-label]');
      if (thumb && opt.dataset.image) thumb.src = opt.dataset.image;
      if (label) label.textContent = (opt.textContent || '').split('—')[0].trim();
      var menu = row.querySelector('[data-dd-menu]');
      if (menu) {
        menu.querySelectorAll('.cbndl__dd-opt').forEach(function (o) {
          o.classList.toggle('is-active', o.getAttribute('data-value') === opt.value);
        });
      }
    }

    /* -- Dieu khien variant picker goc cua Dawn -> Dawn tu doi anh chinh (native, muot) -- */
    function driveMainPicker(select) {
      var opt = select.options[select.selectedIndex];
      var option1 = opt && opt.dataset.option1;
      if (!option1) return;
      var picker = document.querySelector('variant-selects, variant-radios');
      if (!picker) return;
      var done = false;
      picker.querySelectorAll('input[type="radio"]').forEach(function (r) {
        if (!done && r.value === option1) {
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
          done = true;
        }
      });
      if (done) return;
      var sel = picker.querySelector('select');
      if (sel) {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value === option1) {
            sel.selectedIndex = i;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        }
      }
    }

    /* -- Dong/mo dropdown tuy bien -- */
    function closeAllMenus(except) {
      root.querySelectorAll('[data-dd]').forEach(function (dd) {
        if (dd === except) return;
        var m = dd.querySelector('[data-dd-menu]');
        var b = dd.querySelector('[data-dd-btn]');
        if (m) m.hidden = true;
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    function selectedCard() {
      var checked = root.querySelector('.cbndl__radio:checked');
      return checked ? checked.closest('.cbndl__card') : null;
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = !msg;
    }

    /* -- Teaser ngoai: chi hien khi tier chon CHUA du dieu kien (de nhac mua them);
       khi da du (qty >= nguong) thi an vi da co banner trong the -- */
    function updateShipping(card) {
      if (!shipTeaser) return;
      var qty = card ? (parseInt(card.dataset.qty, 10) || 1) : 0;
      shipTeaser.hidden = (freeShipMin && qty >= freeShipMin);
    }

    /* ---------------- Custom name POPUP (Personalisation) ---------------- */
    var modal = root.querySelector('[data-cn-modal]');
    var modalBody = root.querySelector('[data-cn-body]');
    var cnActiveCard = null;

    /* -- Field bat buoc: canh bao + to do o con thieu trong popup -- */
    var requiredLabels = {};
    pfFields.forEach(function (f) { if (f.required && f.label) requiredLabels[f.label] = true; });
    var modalError = null;

    function setModalError(msg) {
      if (!modal) return;
      if (!modalError) {
        modalError = document.createElement('p');
        modalError.className = 'cbndl__modal-error';
        modalError.setAttribute('role', 'alert');
        var foot = modal.querySelector('.cbndl__modal-foot');
        if (foot) foot.parentNode.insertBefore(modalError, foot);
      }
      modalError.textContent = msg || '';
      modalError.hidden = !msg;
    }

    // To do moi o bat buoc con trong trong popup; tra ve o dau tien (hoac null).
    function markMissingInModal() {
      var first = null;
      if (!modalBody) return null;
      Array.prototype.forEach.call(modalBody.querySelectorAll('[data-pf-label]'), function (w) {
        var c = w.querySelector('.cbndl__pf-control');
        var missing = false;
        if (c && requiredLabels[w.getAttribute('data-pf-label')]) {
          missing = c.type === 'file' ? !c.__pfFile : !String(c.value || '').trim();
        }
        w.classList.toggle('is-missing', missing);
        if (missing && !first) first = w;
      });
      return first;
    }

    function focusMissing(w) {
      if (!w) return;
      w.scrollIntoView({ block: 'center', behavior: 'smooth' });
      var input = w.querySelector('input[type="text"].cbndl__pf-control');
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 250);
    }

    // Da hien canh bao -> khach dien toi dau thi go to do toi do.
    if (modalBody) {
      ['input', 'change', 'click'].forEach(function (ev) {
        modalBody.addEventListener(ev, function () {
          if (!modalError || modalError.hidden) return;
          setTimeout(function () { if (!markMissingInModal()) setModalError(''); }, 0);
        });
      });
    }

    // Dong nho "Includes $X personalization" duoi gia the, de khach thay phi da duoc cong.
    function renderFeeNote(card) {
      var note = card.querySelector('.cbndl__fee-note');
      var fee = cardFee(card).total;
      if (!fee) { if (note) note.remove(); return; }
      if (!note) {
        note = document.createElement('div');
        note.className = 'cbndl__fee-note';
        note.style.cssText = 'font-size:.78rem;opacity:.75;margin-top:2px';
        var anchor = card.querySelector('[data-price-block]');
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(note, anchor.nextSibling);
        else card.appendChild(note);
      }
      note.textContent = 'Includes ' + money(fee) + ' personalization';
    }

    // Goi y gia canh nhan field: "(+$5.00)".
    function feeHint(pf) {
      var e = feeEntry(toCents(pf.add_on_price));
      return e ? ' (+' + money(e.price) + ')' : '';
    }

    // Tao 1 control cho field cau hinh (text -> input, dropdown -> select, file -> upload dep).
    function buildFieldControl(pf, value, savedFile) {
      var wrap = document.createElement('div');
      wrap.className = 'cbndl__pf-field';
      wrap.setAttribute('data-pf-label', pf.label || '');

      var lab = document.createElement('label');
      lab.className = 'cbndl__pf-label';
      lab.textContent = (pf.label || '') + (pf.type === 'dropdown' ? '' : feeHint(pf));
      if (pf.required) {
        var star = document.createElement('span');
        star.className = 'cbndl__pf-req';
        star.textContent = ' *';
        lab.appendChild(star);
      }
      wrap.appendChild(lab);

      if (pf.instructions) {
        var hint = document.createElement('div');
        hint.className = 'cbndl__pf-hint';
        hint.textContent = pf.instructions;
        wrap.appendChild(hint);
      }

      if (pf.type === 'dropdown') {
        // Dropdown tu dung (native select khong style duoc list xo xuong).
        var dd = document.createElement('div');
        dd.className = 'cbndl__pf-dd';

        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.className = 'cbndl__pf-control';
        if (value) hidden.value = value;

        var ddBtn = document.createElement('button');
        ddBtn.type = 'button';
        ddBtn.className = 'cbndl__pf-dd-btn';
        var ddLabel = document.createElement('span');
        ddLabel.className = 'cbndl__pf-dd-label';
        ddLabel.textContent = value || 'Select an option';
        if (!value) ddBtn.classList.add('is-placeholder');
        var ddCaret = document.createElement('span');
        ddCaret.className = 'cbndl__pf-dd-caret';
        ddCaret.textContent = '▾';
        ddBtn.appendChild(ddLabel);
        ddBtn.appendChild(ddCaret);

        var ddMenu = document.createElement('div');
        ddMenu.className = 'cbndl__pf-dd-menu';
        ddMenu.hidden = true;

        (pf.options || []).forEach(function (o) {
          var olabel = o && typeof o === 'object' ? o.label : o;
          if (!olabel) return;
          olabel = String(olabel);
          var opt = document.createElement('button');
          opt.type = 'button';
          opt.className = 'cbndl__pf-dd-opt';
          var oe = o && typeof o === 'object' ? feeEntry(toCents(o.price)) : null;
          opt.textContent = olabel + (oe ? ' (+' + money(oe.price) + ')' : '');
          if (olabel === value) opt.classList.add('is-selected');
          opt.addEventListener('click', function (e) {
            e.stopPropagation();
            hidden.value = olabel;
            ddLabel.textContent = olabel;
            ddBtn.classList.remove('is-placeholder');
            Array.prototype.forEach.call(ddMenu.querySelectorAll('.cbndl__pf-dd-opt'), function (x) {
              x.classList.remove('is-selected');
            });
            opt.classList.add('is-selected');
            ddMenu.hidden = true;
            dd.classList.remove('is-open');
          });
          ddMenu.appendChild(opt);
        });

        ddBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          Array.prototype.forEach.call(document.querySelectorAll('.cbndl__pf-dd.is-open'), function (d) {
            if (d !== dd) {
              d.classList.remove('is-open');
              var m = d.querySelector('.cbndl__pf-dd-menu');
              if (m) m.hidden = true;
            }
          });
          var willOpen = ddMenu.hidden;
          ddMenu.hidden = !willOpen;
          dd.classList.toggle('is-open', willOpen);
        });

        dd.appendChild(ddBtn);
        dd.appendChild(ddMenu);
        dd.appendChild(hidden);
        wrap.appendChild(dd);
      } else if (pf.type === 'file') {
        var fileWrap = document.createElement('div');
        fileWrap.className = 'cbndl__pf-file';

        var input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*,.pdf,.svg,.heic';
        input.className = 'cbndl__pf-control cbndl__pf-file-input';
        input.__pfFile = savedFile || null;

        var dropzone = document.createElement('div');
        dropzone.className = 'cbndl__pf-dropzone';
        dropzone.innerHTML =
          '<span class="cbndl__pf-dz-icon">⬆</span>' +
          '<span class="cbndl__pf-dz-text">Click or drag a file here</span>' +
          '<span class="cbndl__pf-dz-sub">Image, PDF, SVG</span>';

        var preview = document.createElement('div');
        preview.className = 'cbndl__pf-file-preview';

        function showFile(file) {
          input.__pfFile = file || null;
          preview.innerHTML = '';
          if (file) {
            if (/^image\//.test(file.type)) {
              var img = document.createElement('img');
              img.className = 'cbndl__pf-thumb';
              img.src = URL.createObjectURL(file);
              preview.appendChild(img);
            } else {
              var ic = document.createElement('span');
              ic.className = 'cbndl__pf-fileicon';
              ic.textContent = '📄';
              preview.appendChild(ic);
            }

            var rm = document.createElement('button');
            rm.type = 'button';
            rm.className = 'cbndl__pf-file-remove';
            rm.setAttribute('aria-label', 'Remove file');
            rm.textContent = '✕';
            rm.addEventListener('click', function (e) {
              e.stopPropagation();
              input.value = '';
              showFile(null);
            });
            preview.appendChild(rm);

            dropzone.style.display = 'none';
            preview.style.display = 'inline-block';
          } else {
            preview.style.display = 'none';
            dropzone.style.display = 'flex';
          }
        }

        dropzone.addEventListener('click', function () { input.click(); });
        input.addEventListener('change', function () {
          if (input.files && input.files[0]) showFile(input.files[0]);
        });
        ['dragenter', 'dragover'].forEach(function (ev) {
          dropzone.addEventListener(ev, function (e) {
            e.preventDefault();
            dropzone.classList.add('is-drag');
          });
        });
        ['dragleave', 'dragend', 'drop'].forEach(function (ev) {
          dropzone.addEventListener(ev, function () { dropzone.classList.remove('is-drag'); });
        });
        dropzone.addEventListener('drop', function (e) {
          e.preventDefault();
          var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
          if (!f) return;
          try {
            var dt = new DataTransfer();
            dt.items.add(f);
            input.files = dt.files;
          } catch (err) {}
          showFile(f);
        });

        fileWrap.appendChild(input);
        fileWrap.appendChild(dropzone);
        fileWrap.appendChild(preview);
        wrap.appendChild(fileWrap);
        showFile(savedFile || null);
      } else {
        var inp = document.createElement('input');
        inp.type = 'text';
        inp.className = 'cbndl__pf-control';
        if (pf.char_limit) inp.maxLength = parseInt(pf.char_limit, 10) || 256;
        inp.placeholder = 'Type here';
        if (value) inp.value = value;
        wrap.appendChild(inp);
      }
      return wrap;
    }

    function buildCnModal(card) {
      if (!card || !modalBody) return;
      var qty = parseInt(card.dataset.qty, 10) || 1;
      var selects = card.querySelectorAll('.cbndl__select');
      var names = card.__cnNames || [];
      modalBody.innerHTML = '';
      for (var i = 0; i < qty; i++) {
        var sel = selects[i];
        var opt = sel ? sel.options[sel.selectedIndex] : null;
        var imgSrc = opt && opt.dataset.image ? opt.dataset.image : '';
        var color = sel ? optData(sel).label.split('—')[0].trim() : '';

        var rowEl = document.createElement('div');
        rowEl.className = 'cbndl__cn-row';

        var im = document.createElement('img');
        im.className = 'cbndl__cn-img';
        im.src = imgSrc;
        im.alt = '';
        rowEl.appendChild(im);

        var field = document.createElement('div');
        field.className = 'cbndl__cn-field';

        var nm = document.createElement('div');
        nm.className = 'cbndl__cn-name';
        nm.textContent = productTitle + ' #' + (i + 1);
        field.appendChild(nm);

        var vr = document.createElement('div');
        vr.className = 'cbndl__cn-variant';
        vr.textContent = color;
        field.appendChild(vr);

        if (useFields) {
          var savedForUnit = (card.__cnFields || [])[i] || {};
          var savedFilesUnit = (card.__cnFiles || [])[i] || {};
          pfFields.forEach(function (pf) {
            field.appendChild(buildFieldControl(pf, savedForUnit[pf.label], savedFilesUnit[pf.label]));
          });
        } else {
          var inp = document.createElement('input');
          inp.type = 'text';
          inp.className = 'cbndl__cn-input';
          inp.maxLength = 30;
          inp.placeholder = 'Type here';
          inp.value = names[i] || '';
          field.appendChild(inp);

          var cnt = document.createElement('div');
          cnt.className = 'cbndl__cn-count';
          var cs = document.createElement('span');
          cs.textContent = String(inp.value.length);
          cnt.appendChild(cs);
          cnt.appendChild(document.createTextNode('/30'));
          field.appendChild(cnt);

          inp.addEventListener('input', (function (span) {
            return function () { span.textContent = String(this.value.length); };
          })(cs));
        }

        rowEl.appendChild(field);
        modalBody.appendChild(rowEl);
      }
    }

    function openModal() { if (modal) { modal.hidden = false; document.body.style.overflow = 'hidden'; } }
    function closeModal() { if (modal) { modal.hidden = true; document.body.style.overflow = ''; } }

    root.querySelectorAll('[data-cn-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        cnActiveCard = btn.closest('.cbndl__card');
        buildCnModal(cnActiveCard);
        setModalError('');
        openModal();
      });
    });
    root.querySelectorAll('[data-cn-close], [data-cn-cancel]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    var confirmBtn = root.querySelector('[data-cn-confirm]');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        if (cnActiveCard && modalBody) {
          if (useFields) {
            var missingField = markMissingInModal();
            if (missingField) {
              setModalError('Please fill in all required fields (marked *).');
              focusMissing(missingField);
              return;
            }
            var rows = modalBody.querySelectorAll('.cbndl__cn-row');
            var newFields = [];
            var newFiles = [];
            Array.prototype.forEach.call(rows, function (row) {
              var obj = {};
              var fileObj = {};
              Array.prototype.forEach.call(row.querySelectorAll('[data-pf-label]'), function (w) {
                var label = w.getAttribute('data-pf-label');
                var c = w.querySelector('.cbndl__pf-control');
                if (!label || !c) return;
                if (c.type === 'file') {
                  if (c.__pfFile) fileObj[label] = c.__pfFile;
                } else if (c.value.trim()) {
                  obj[label] = c.value.trim();
                }
              });
              newFields.push(obj);
              newFiles.push(fileObj);
            });
            cnActiveCard.__cnFields = newFields;
            cnActiveCard.__cnFiles = newFiles;
            var filledF = newFields.filter(function (o) { return Object.keys(o).length; }).length
              + newFiles.filter(function (o) { return Object.keys(o).length; }).length;
            var openBtnF = cnActiveCard.querySelector('[data-cn-open]');
            if (openBtnF) openBtnF.classList.toggle('cbndl__cn-open--filled', filledF > 0);
            renderCardPrice(cnActiveCard);
            renderFeeNote(cnActiveCard);
          } else {
            var inputs = modalBody.querySelectorAll('.cbndl__cn-input');
            cnActiveCard.__cnNames = Array.prototype.map.call(inputs, function (i) { return i.value.trim(); });
            var filled = cnActiveCard.__cnNames.filter(Boolean).length;
            var openBtn = cnActiveCard.querySelector('[data-cn-open]');
            if (openBtn) openBtn.classList.toggle('cbndl__cn-open--filled', filled > 0);
          }
        }
        closeModal();
      });
    }
    // Dua modal ra thang <body> de position:fixed luon phu ca man hinh
    // (tranh bi "nhot" trong cot info neu theme co transform/sticky). Giu accent.
    if (modal) {
      var accentVal = getComputedStyle(root).getPropertyValue('--cb-accent');
      if (accentVal) modal.style.setProperty('--cb-accent', accentVal.trim());
      document.body.appendChild(modal);
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    // Bam ra ngoai -> dong moi dropdown personalization dang mo.
    document.addEventListener('click', function () {
      Array.prototype.forEach.call(document.querySelectorAll('.cbndl__pf-dd.is-open'), function (d) {
        d.classList.remove('is-open');
        var m = d.querySelector('.cbndl__pf-dd-menu');
        if (m) m.hidden = true;
      });
    });

    /* ---------------- Dropdown tuy bien: wiring ---------------- */
    function wireDropdown(dd) {
      var btn = dd.querySelector('[data-dd-btn]');
      var menu = dd.querySelector('[data-dd-menu]');
      var row = dd.closest('.cbndl__selector-row');
      var select = row ? row.querySelector('.cbndl__select') : null;
      if (!btn || !menu || !select) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var willOpen = menu.hidden;
        closeAllMenus(dd);
        menu.hidden = !willOpen;
        btn.setAttribute('aria-expanded', String(willOpen));
      });

      menu.querySelectorAll('.cbndl__dd-opt').forEach(function (optBtn) {
        optBtn.addEventListener('click', function (e) {
          e.preventDefault();
          if (optBtn.hasAttribute('disabled')) return;
          select.value = optBtn.getAttribute('data-value');
          select.dispatchEvent(new Event('change', { bubbles: true }));
          menu.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
        });
      });
    }
    root.querySelectorAll('[data-dd]').forEach(wireDropdown);
    // Dong menu khi click ra ngoai
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-dd]')) closeAllMenus(null);
    });

    /* ---------------- Wire up events ---------------- */
    var suppress = false; // chan vong lap khi sync 2 chieu picker <-> tier

    function wireSelect(s) {
      s.addEventListener('change', function () {
        var card = s.closest('.cbndl__card');
        renderCardPrice(card);
        updateDropdownDisplay(s);
        suppress = true; driveMainPicker(s); suppress = false; // chon o nao -> anh chinh + Color tren cung theo o do
        showError('');
      });
      updateDropdownDisplay(s);
    }
    root.querySelectorAll('.cbndl__select').forEach(wireSelect);

    /* -- Bac cao nhat: nut -/+ mua them (min = so chiec cua bac, % giu nguyen).
       Them chiec = them 1 o chon mau (cung mau o cuoi); bot chiec = bo o cuoi va
       ca ten / field ca nhan hoa cua chiec do. -- */
    function setCardQty(card, qty) {
      var min = parseInt(card.dataset.minQty, 10) || 1;
      var max = parseInt(card.dataset.maxQty, 10) || min;
      qty = Math.max(min, Math.min(max, qty));
      var box = card.querySelector('[data-selectors]');
      var tpl = card.querySelector('[data-selector-tpl]');
      if (!box || !tpl) return;

      var rows = box.querySelectorAll('.cbndl__selector-row');
      for (var n = rows.length; n < qty; n++) {
        var last = box.querySelector('.cbndl__selector-row:last-child .cbndl__select');
        var frag = tpl.content.cloneNode(true);
        var row = frag.querySelector('.cbndl__selector-row');
        var sel = row.querySelector('.cbndl__select');
        sel.setAttribute('data-unit-index', String(n));
        if (last) sel.value = last.value;
        box.appendChild(frag);
        wireDropdown(row.querySelector('[data-dd]'));
        wireSelect(sel);
      }
      for (var k = rows.length - 1; k >= qty; k--) rows[k].remove();

      ['__cnNames', '__cnFields', '__cnFiles'].forEach(function (key) {
        if (card[key] && card[key].length > qty) card[key] = card[key].slice(0, qty);
      });
      var openBtn = card.querySelector('[data-cn-open]');
      if (openBtn) {
        var anyFilled = (card.__cnNames || []).some(Boolean) ||
          (card.__cnFields || []).concat(card.__cnFiles || []).some(function (o) { return Object.keys(o).length; });
        openBtn.classList.toggle('cbndl__cn-open--filled', anyFilled);
      }

      card.dataset.qty = String(qty);
      var val = card.querySelector('[data-qty-val]');
      if (val) val.textContent = String(qty);
      var minus = card.querySelector('[data-qty-minus]');
      var plus = card.querySelector('[data-qty-plus]');
      if (minus) minus.disabled = qty <= min;
      if (plus) plus.disabled = qty >= max;

      renderCardPrice(card);
      renderFeeNote(card);
      if (card === selectedCard()) updateShipping(card);
      showError('');
    }

    root.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
      var card = stepper.closest('.cbndl__card');
      if (!card) return;
      var minus = stepper.querySelector('[data-qty-minus]');
      var plus = stepper.querySelector('[data-qty-plus]');
      function step(d) {
        return function (e) {
          e.preventDefault();
          setCardQty(card, (parseInt(card.dataset.qty, 10) || 1) + d);
        };
      }
      if (minus) minus.addEventListener('click', step(-1));
      if (plus) plus.addEventListener('click', step(1));
      setCardQty(card, parseInt(card.dataset.qty, 10) || 1);
    });

    cards.forEach(function (card) {
      renderCardPrice(card);
      var radio = card.querySelector('.cbndl__radio');
      radio.addEventListener('change', function () {
        if (radio.checked) {
          updateShipping(card);
          showError('');
        }
      });
    });

    updateShipping(selectedCard());

    /* -- Chieu nguoc: click Color o variant picker goc -> dien mau vao TAT CA o tier -- */
    function currentPickerColor() {
      var picker = document.querySelector('variant-selects, variant-radios');
      if (!picker) return null;
      var fs = picker.querySelector('fieldset') || picker;
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;
      var sel = picker.querySelector('select');
      return sel ? sel.value : null;
    }
    function fillTiersFromColor(color) {
      if (!color) return;
      root.querySelectorAll('.cbndl__select').forEach(function (s) {
        var matched = false;
        for (var i = 0; i < s.options.length; i++) {
          if (s.options[i].dataset.option1 === color) { s.selectedIndex = i; matched = true; break; }
        }
        if (!matched) return;
        renderCardPrice(s.closest('.cbndl__card'));
        updateDropdownDisplay(s);
      });
    }
    // Dung event delegation tren document: Dawn REPLACE phan tu variant-selects
    // moi lan doi variant, nen listener gan truc tiep chi an 1 lan. Nghe o document
    // (change bubbles) thi song sot qua moi lan re-render.
    document.addEventListener('change', function (e) {
      if (suppress) return; // bo qua khi chinh widget vua dieu khien picker
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('variant-selects, variant-radios')) return;
      fillTiersFromColor(currentPickerColor());
    });

    /* ---------------- Submit -> /cart/add.js ---------------- */
    function setLoading(state) {
      submitBtn.disabled = state;
      if (spinner) spinner.hidden = !state;
      if (submitText) submitText.style.opacity = state ? '.6' : '1';
    }

    submitBtn.addEventListener('click', function () {
      showError('');
      var card = selectedCard();
      if (!card) { showError('Please choose an option.'); return; }

      var selects = card.querySelectorAll('.cbndl__select');
      var names = card.__cnNames || [];
      var bundleId = 'bndl_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      var tierDiscount = parseInt(card.dataset.discount, 10) || 0;

      // Bat buoc: field required (che do fields) phai duoc dien cho moi mon.
      if (enableCustomName && useFields) {
        var reqFields = pfFields.filter(function (f) { return f.required; });
        if (reqFields.length) {
          var qtyN = parseInt(card.dataset.qty, 10) || 1;
          var fpu = card.__cnFields || [];
          var flu = card.__cnFiles || [];
          for (var u = 0; u < qtyN; u++) {
            var uf = fpu[u] || {};
            var ufl = flu[u] || {};
            for (var r = 0; r < reqFields.length; r++) {
              var lb = reqFields[r].label;
              var ok = reqFields[r].type === 'file' ? !!ufl[lb] : !!uf[lb];
              if (!ok) {
                // Mo popup cua dung goi dang chon, to do o con thieu thay vi chi bao 1 dong chu.
                showError('Please complete the required personalization.');
                cnActiveCard = card;
                buildCnModal(card);
                openModal();
                setModalError('Please fill in all required fields (marked *) before adding to cart.');
                focusMissing(markMissingInModal());
                return;
              }
            }
          }
        }
      }

      var tierTitle = card.dataset.title || '';
      var tierQty = parseInt(card.dataset.qty, 10) || 1;

      var items = [];
      var soldOut = false;
      selects.forEach(function (s, idx) {
        var d = optData(s);
        if (!d.available) { soldOut = true; return; }
        var props = { _bundle_id: bundleId };
        if (tierDiscount > 0) props._bundle_discount = String(tierDiscount);
        // Human-readable summary for Admin order view (kept hidden from customer via
        // leading underscore) so merchants don't just see an opaque _bundle_id hash.
        if (tierTitle) props._Bundle = tierTitle + ' (' + tierQty + (tierQty === 1 ? ' item)' : ' items)');
        if (enableCustomName) {
          if (personalizationMode === 'fields') {
            if (useFields) {
              var unitFields = (card.__cnFields || [])[idx] || {};
              Object.keys(unitFields).forEach(function (k) { props[k] = unitFields[k]; });
              var unitFiles = (card.__cnFiles || [])[idx] || {};
              Object.keys(unitFiles).forEach(function (k) { if (unitFiles[k]) props[k] = unitFiles[k]; });
            }
          } else if (names[idx]) {
            props['Custom Name'] = names[idx];
          }
        }
        // Phi cua mon nay (cho guard doi chieu): "variantId:soLuong,..." (an, bat dau bang _).
        var comps = useFields ? unitFeeComponents(card, idx) : [];
        if (comps.length) {
          var per = {};
          comps.forEach(function (c) { var e = feeEntry(c); if (e) per[e.id] = (per[e.id] || 0) + 1; });
          var spec = Object.keys(per).map(function (vid) { return vid + ':' + per[vid]; }).join(',');
          if (spec) { props._fee = spec; props._fee_key = bundleId; }
        }
        items.push({ id: parseInt(d.id, 10), quantity: 1, properties: props });
      });

      // Dong phi: cung request nen them gio la nguyen tu (loi o dau thi khong them gi).
      var feeItems = [];
      var feeByVariant = cardFee(card).byVariant;
      Object.keys(feeByVariant).forEach(function (vid) {
        feeItems.push({ id: parseInt(vid, 10), quantity: feeByVariant[vid].qty, properties: { _personalization_fee: 'true', _fee_for: bundleId } });
      });

      if (soldOut) { showError('One of the selected colors is sold out. Please pick another.'); return; }
      if (!items.length) { showError('Please select at least one color.'); return; }
      // Phi can thu nhung khong con variant phi dung: dung lai, khong cho mua thieu tien.
      var needFee = items.some(function (it) { return it.properties._fee; });
      if (needFee && !feeItems.length) { showError('Personalization is unavailable right now. Please try again later.'); return; }
      var allItems = items.concat(feeItems);

      setLoading(true);

      var addPromise;
      if (useFields && hasFileField) {
        // Co field file -> add tung mon bang multipart/form-data (JSON khong gui file).
        addPromise = items.reduce(function (chain, it) {
          return chain.then(function (acc) {
            var fd = new FormData();
            fd.append('id', String(it.id));
            fd.append('quantity', '1');
            Object.keys(it.properties).forEach(function (k) {
              fd.append('properties[' + k + ']', it.properties[k]);
            });
            return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
              .then(function (res) { return res.json().then(function (d) { if (!res.ok) throw d; acc.push(d); return acc; }); });
          });
        }, Promise.resolve([])).then(function (added) {
          // Phi them cuoi cung (multipart cung dang dung cho cac mon o tren).
          return feeItems.reduce(function (chain, it) {
            return chain.then(function (acc) {
              var fd = new FormData();
              fd.append('id', String(it.id));
              fd.append('quantity', String(it.quantity));
              Object.keys(it.properties).forEach(function (k) { fd.append('properties[' + k + ']', it.properties[k]); });
              return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
                .then(function (res) { return res.json().then(function (d) { if (!res.ok) throw d; acc.push(d); return acc; }); });
            });
          }, Promise.resolve(added)).then(function (all) { return { items: all }; });
        });
      } else {
        addPromise = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: allItems })
        }).then(function (res) { return res.json().then(function (data) { if (!res.ok) throw data; return data; }); });
      }

      addPromise
  .then(function (added) {
    // Gan ma giam gia bundle (bundle-code-guard.js) TRUOC khi hien gio / chuyen trang.
    var syncCodes = function () {
      return window.bundleCodeGuardRun ? window.bundleCodeGuardRun().catch(function () {}) : Promise.resolve();
    };
    if (cartBehavior === 'redirect') { syncCodes().then(function () { window.location.href = '/cart'; }); return; }

    // 1. Tải HTML giỏ hàng mới nhất từ server về
    return syncCodes()
      .then(function () { return fetch('/cart?section_id=cart-drawer'); })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('#CartDrawer');
        var curDrawer = document.querySelector('#CartDrawer');
        if (newDrawer && curDrawer) {
          curDrawer.innerHTML = newDrawer.innerHTML;
        }
        var drawerTag = document.querySelector('cart-drawer');
        if (drawerTag) drawerTag.classList.remove('is-empty');
      })
      .catch(function (e) { console.error(e); })
      .then(function () {
        // 2. Cập nhật số lượng hiển thị lên icon giỏ hàng trên Header
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var iconBubble = document.querySelector('#cart-icon-bubble');
            if (iconBubble && cart.item_count > 0) {
              var bubble = iconBubble.querySelector('.cart-count-bubble');
              if (!bubble) {
                bubble = document.createElement('div');
                bubble.className = 'cart-count-bubble';
                iconBubble.appendChild(bubble);
              }
              bubble.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span><span class="visually-hidden">' + cart.item_count + ' items</span>';
            }
          })
          .catch(function () {});

        // 3. Mở ngăn kéo giỏ hàng
        return refreshCartCount().then(function (cart) {
          var opened = cartBehavior !== 'count' ? notifyThemeCart(cart, added.items || allItems) : false;
          if (!opened) {
            var drawerTag = document.querySelector('cart-drawer');
            if (drawerTag && typeof drawerTag.open === 'function') {
              drawerTag.open();
              opened = true;
            }
          }
          if (!opened) showToast('Added to cart ✓');
        });
      });
  })
  .catch(function (err) {
    var msg = (err && (err.description || err.message)) || 'Could not add to cart. Please try again.';
    showError(msg);
  })
  .finally(function () { setLoading(false); });
});
}

// Bắt sự kiện bấm ra ngoài lớp phủ (overlay) để tắt giỏ hàng
document.addEventListener('click', function (e) {
  if (
    e.target &&
    (e.target.id === 'CartDrawer-Overlay' ||
     e.target.classList.contains('cart-drawer__overlay') ||
     e.target.closest('#CartDrawer-Overlay'))
  ) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.close === 'function') {
      drawer.close();
    } else if (drawer) {
      drawer.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  }
});

function bootAll() { document.querySelectorAll('[data-cbndl]').forEach(initBundle); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
else bootAll();
document.addEventListener('shopify:section:load', function (e) {
  var el = e.target.querySelector ? e.target.querySelector('[data-cbndl]') : null;
  if (el) initBundle(el);
});
})();
